import {
  IonBackButton,
  IonButtons,
  IonCard,
  IonContent,
  IonHeader,
  IonLabel,
  IonListHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  isPlatform,
} from "@ionic/react";
import React from "react";
import { useDispatch } from "react-redux";
import { resetDataMiDt } from "../../../store/fichaMiDt";
import { InputMiDt } from "./components/InputMiDt";
import { StepMiDtList } from "./components/StepMiDtList";

export const FichaMiDt: React.FC = () => {
  const dispatch = useDispatch();
  dispatch(resetDataMiDt());
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton color="light" defaultHref="/app/rrhh" />
          </IonButtons>
          <IonTitle>Ficha MiDt</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <section className={isPlatform("desktop") ? "ion-padding" : ""}>
          <IonListHeader>
            <IonLabel>
              <h2>
                <strong>MiDt</strong>
              </h2>
            </IonLabel>
          </IonListHeader>
          <IonCard>
            <InputMiDt />
            <StepMiDtList />
          </IonCard>
        </section>
      </IonContent>
    </IonPage>
  );
};
